/**
 * Created with IntelliJ IDEA.
 * User: nzamuruev
 * Date: 14.02.14
 * Time: 12:58
 * To change this template use File | Settings | File Templates.
 */
export class ClickSourceTrackingConstants {
    // only for click-events
    public static USER_STATE_PANEL: number = 1;
    public static NO_MONEY_C2: number = 2;
    public static FIGHT_SCREEN: number = 3;

    //
    public static SPECIAL_OFFER: number = 4;
    public static SPECIAL_OFFER_BETTER: number = 5;
    public static PREMIUM_MARKET_PLACE: number = 6;
    public static DYNAMIC_PAYMENT_REWARD: number = 7;
    public static PAYMENT_REWARD: number = 8;
    public static PRIVATE_OFFER_DECORATION: number = 9;
    public static PRIVATE_PRIME_TIME_OFFER: number = 10;
    public static ALLI_PAYMENT_BONUS: number = 11;
    public static PRIVATE_OFFER_COINMINE: number = 12;
}

